import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import ZoomableButtonGroup from 'automation-ui-canvas/components/canvas/ZoomableButtonGroup';
import wireFlow from 'automation-ui-canvas/decorators/WiredFlowDecorator';
import UndoRedoButton from 'automation-ui-canvas/containers/undo-redo/UndoRedoButton';
import { jsx as _jsx } from "react/jsx-runtime";
const UndoRedoContainer = ({
  flowId,
  flow,
  isMinimized,
  buttonTheme
}) => {
  const currentVersion = flow && flow.version;
  if (!flow) {
    return null;
  }
  return /*#__PURE__*/_jsx(ZoomableButtonGroup, {
    marginInlineEnd: "200",
    isMinimized: isMinimized,
    children: ['UNDO', 'REDO'].map(requestType => /*#__PURE__*/_jsx(UndoRedoButton, {
      flowId: flowId,
      currentVersion: currentVersion,
      use: buttonTheme,
      requestType: requestType
    }, requestType))
  });
};
export default compose(withRouter, wireFlow)(UndoRedoContainer);